import axios from 'axios';
import { CART_URL, X_TENANT_ID } from '../../common/ActionUrl';
import { fetchProductsByIds } from '../products/productsAPIUtil';
const publicIp = require('react-public-ip');

const requestOptions = {
  headers: { 'X-TENANT-ID': X_TENANT_ID },
};

const serializeCartItemsForAPI = (cartItems = []) => {
  return (cartItems || []).map((item) => {
    const {
      currentOrder,
      dateTime,
      pending,
      isKitChildProduct,
      kitStartingQuantity,
      kitChangeQuantity,
      kitPriceMode,
      product = {},
    } = item || {};

    const minimalProduct = {
      id: product?.id, // required
      cartItemId: product?.cartItemId, // required for client updates
      kitId: product?.kitId, // kit linkage if present
      parentCartItemId: product?.parentCartItemId, // kit parent if present
      selectedProductColor: product?.selectedProductColor, // selected color
      selectedProductSize: product?.selectedProductSize, // selected size
      isPrintable: product?.isPrintable, // flag to know it is print product
      printValues: product?.printValues, // it has an important attribute known as formValues, all the details filled in print products
    };

    return {
      currentOrder,
      dateTime,
      pending,
      isKitChildProduct,
      kitStartingQuantity,
      kitChangeQuantity,
      kitPriceMode,
      product: minimalProduct,
    };
  });
};

export const updateCart = async (data, publicIpLoaded) => {
  let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : '';
  const cartSession = localStorage.getItem('-') || '';
  let userId = user?.userId ? user?.userId : null;
  const ipv4 = !!publicIpLoaded ? publicIpLoaded : await publicIp.v4();
  const serialized = serializeCartItemsForAPI(data);
  let res = {
    cartItems: serialized,
    userId: userId ? userId : cartSession,
    ipAddress: ipv4,
  };
  return axios.post(`${CART_URL}`, res, requestOptions);
};

export const getCartById = async (user, publicIpLoaded) => {
  const userId = user?.userId ? user?.userId : null;
  const cartSession = localStorage.getItem('-') || '';
  const ipv4 = !!publicIpLoaded ? publicIpLoaded : await publicIp.v4();

  const param = userId ? userId : cartSession;
  if (!param)
    return {
      cartItems: [],
    };
  const cart = await axios.get(`${CART_URL}/${param}/${ipv4}`, requestOptions);
  if (cart?.data?.length > 0) {
    const _id = cart?.data?.[0]?._id;
    const serverItems = cart?.data?.[0]?.cartItems ?? [];

    const ids = [...new Set(serverItems.map((ci) => ci?.product?.id).filter(Boolean))];

    // fetch full products and index by id
    let productsById = {};
    if (ids.length) {
      try {
        const { data } = await fetchProductsByIds(ids);
        const list = data?.results ?? data ?? [];
        productsById = (list || []).reduce((acc, p) => {
          acc[p.id] = p;
          return acc;
        }, {});
      } catch (e) {
        console.error('Error hydrating cart products', e);
      }
    }

    // merge hydrated product into each cart item
    const hydrated = serverItems.map((ci) => {
      const minimal = ci?.product || {};
      const full = minimal?.id ? productsById[minimal.id] : null;
      return {
        ...ci,
        product: full
          ? {
              ...full,
              cartItemId: minimal.cartItemId,
              kitId: minimal.kitId,
              parentCartItemId: minimal.parentCartItemId,
              selectedProductColor: minimal?.selectedProductColor,
              selectedProductSize: minimal?.selectedProductSize,
              isPrintable: minimal?.isPrintable,
              printValues: minimal?.printValues,
            }
          : minimal, // fallback to minimal if not found
      };
    });

    return {
      _id,
      cartItems: hydrated,
    };
  }
};

export const getCartList = () => {
  return axios.get(CART_URL, requestOptions);
};

export const updateUserIdCart = async (user, publicIpLoaded) => {
  const ipAddress = !!publicIpLoaded ? publicIpLoaded : await publicIp.v4();
  const userId = user?.userId ? user?.userId : null;
  const cartId = localStorage.getItem('-');
  if (cartId && userId) {
    let req = {
      userId,
      cartId,
      ipAddress,
    };
    return axios.post(`${CART_URL}/update-userid`, req, requestOptions);
  }
};
